<template>
  <div class="historyOverview">
    <div class="row">
      <div class="col-12 mb-4">
        <HistoryComments
          ref="Notelist"
          @showNoteAdd="show"
        />
      </div>
      <div class="col-12 mb-4">
        <HistoryCountChart />
      </div>
      <div class="col-12">
        <BusiestInstallations />
      </div>
    </div>
    <Sidebar
      v-if="showSidebar"
      :show-sidebar="showSidebar"
      @close="close"
    >
      <InstallationNote
        :installation-id="installationId"
        @close="close"
      />
    </Sidebar>
  </div>
</template>

<script>
export default {
  name: "HistoryOverview",
  components: {
    HistoryCountChart: () =>
      import("@/components/History/HistoryCountChart.vue"),
    BusiestInstallations: () =>
      import("@/components/History/BusiestInstallations.vue"),
    HistoryComments: () => import("@/components/History/HistoryComments.vue"),
    Sidebar: () => import("@/components/Base/Sidebar.vue"),
    InstallationNote: () =>
      import("@/components/Installation/InstallationNote.vue"),
  },
  data() {
    return {
      resizeListener: null,
      showSidebar: false,
      installationId: null,
    };
  },
  created() {
    this.resizeListener = window.addEventListener(
      "resize",
      this.computeDisplay
    );
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.computeDisplay);
    this.resizeListener = null;
  },
  methods: {
    show(id) {
      this.installationId = id;
      this.showSidebar = true;
    },
    close() {
      this.installationId = null;
      this.showSidebar = false;
      if (this.$refs.Notelist && this.$refs.Notelist.refresh) {
        this.$refs.Notelist.refresh();
      }
    },
  },
};
</script>
